import React from 'react'
// import Bushra_cv from '../assets/CVs/Bioinformatics/Dr. bushra Ahmad updated Curiiculum Vitea.pdf'
import common from '../assets/common.jpg'
import './TeacherCard.css'


const TeacherCard = (props) => {
  return (
    <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
              <div className="member-info">
              <h4>{props.name}</h4>
              <span>{props.profile_name}</span>
              <p className='intro'>{props.intro} </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i> {props.email} </p>
              <div className="social">
                <a href={props.cv}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href={props.google}><i className="bi bi-google"></i></a>
                <a href={props.linkedin}><i className="bi bi-linkedin"></i></a>
                
              </div>
            </div>
          </div>
        </div>      
  )
}

export default TeacherCard
